<div fxFlex>
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
      <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
          <mat-card [style.background-color]="uiData.color" fxFlex="100">
              <h2 class="noMarginHeader">
                  <mat-icon>{{uiData.icon}}</mat-icon> {{'Call Tracker Metrics'}}
              </h2>
          </mat-card>
      </div>
  </div>
  <div fxLayout="column" fxLayoutGap="5px">
    <mat-card fxFlex="100">
      <form [formGroup]="universalUpdateForm" (ngSubmit)="updateAll()">
        <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxFlexFill>
          <mat-form-field fxFlex>
            <mat-label>From</mat-label>
            <input matInput [matDatepicker]="expirationStartPicker" placeholder="From" formControlName="from" (keydown.enter)="updateAll()">
            <mat-datepicker-toggle matSuffix [for]="expirationStartPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear date" (click)="universalUpdateForm.get('from')?.reset()" type="button">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #expirationStartPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field fxFlex>
            <mat-label>To</mat-label>
            <input matInput [matDatepicker]="expirationEndPicker" placeholder="To" formControlName="to" (keydown.enter)="updateAll()">
            <mat-datepicker-toggle matSuffix [for]="expirationEndPicker"></mat-datepicker-toggle>
            <button matSuffix mat-icon-button aria-label="Clear date" (click)="universalUpdateForm.get('to')?.reset()" type="button">
              <mat-icon style="color: red;">close</mat-icon>
            </button>
            <mat-datepicker #expirationEndPicker></mat-datepicker>
          </mat-form-field>
          <div fxFlex="none" style="display: flex; align-items: center;">
            <button mat-raised-button color="primary" type="submit">Update All</button>
          </div>
        </div>
      </form>
    </mat-card>    
    <div fxFlex fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="stretch stretch" style="height:100%;">
      <!-- Status Counts Card -->
      <div fxFlex="50" fxFlexFill style="min-width:320px;">
        <form [formGroup]="statusForm" (ngSubmit)="getStatusMetrics()">
          <mat-card class="full-height">
            <mat-card-header>
              <span><strong>Status Counts</strong></span>
            </mat-card-header>
            <mat-card-content style="flex: 1 1 auto;">
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" style="margin-bottom: 8px;">
                <mat-form-field fxFlex>
                  <mat-label>From</mat-label>
                  <input matInput [matDatepicker]="statusFromPicker" placeholder="From" formControlName="from">
                  <mat-datepicker-toggle matSuffix [for]="statusFromPicker"></mat-datepicker-toggle>
                  <button matSuffix mat-icon-button aria-label="Clear date" (click)="statusForm.get('from')?.reset()" type="button">
                    <mat-icon style="color: red;">close</mat-icon>
                  </button>
                  <mat-datepicker #statusFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex>
                  <mat-label>To</mat-label>
                  <input matInput [matDatepicker]="statusToPicker" placeholder="To" formControlName="to">
                  <mat-datepicker-toggle matSuffix [for]="statusToPicker"></mat-datepicker-toggle>
                  <button matSuffix mat-icon-button aria-label="Clear date" (click)="statusForm.get('to')?.reset()" type="button">
                    <mat-icon style="color: red;">close</mat-icon>
                  </button>
                  <mat-datepicker #statusToPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <hr />
              <table class="table table-sm table-borderless wide-table">
                <thead>
                  <tr>
                    <th scope="col">Status</th>
                    <th scope="col">Count</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Closed</td>
                    <td>{{statusCounts.closed}}</td>
                  </tr>
                  <tr>
                    <td>Open</td>
                    <td>{{statusCounts.open}}</td>
                  </tr>
                  <tr>
                    <td>Total</td>
                    <td>{{statusCounts.total}}</td>
                  </tr>
                </tbody>
              </table>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button color="primary" type="submit">Update</button>
            </mat-card-actions>
          </mat-card>
        </form>
      </div>

      <!-- Hours/Dollars by Program/Topic Card -->
      <div fxFlex="50" fxFlexFill style="min-width:350px;">
        <form [formGroup]="costForm" (ngSubmit)="getCostMetrics()">
          <mat-card class="full-height">
            <mat-card-header>
              <strong>Hours/Dollars by Program/Topic</strong>
            </mat-card-header>
            <mat-card-content style="flex: 1 1 auto;">
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" style="margin-top: 5pt;">
                <mat-form-field fxFlex>
                  <mat-label>Primary Topic</mat-label>
                  <mat-select formControlName="topicId" (selectionChange)="updateSecondaryTopics($event.value)">
                    <mat-option [value]="0">Select a Topic</mat-option>
                    <mat-option *ngFor="let topic of primaryTopics" [value]="topic.topicId">{{topic.shortDescription}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field fxFlex *ngIf="secondaryTopics.length > 0">
                  <mat-label>Secondary Topic</mat-label>
                  <mat-select formControlName="secondTopicId" (selectionChange)="updateTertiaryTopics($event.value)">
                    <mat-option [value]="0">Select a Topic</mat-option>
                    <mat-option *ngFor="let topic of secondaryTopics" [value]="topic.topicId">{{topic.shortDescription}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field fxFlex *ngIf="tertiaryTopics.length > 0">
                  <mat-label>Tertiary Topic</mat-label>
                  <mat-select formControlName="tertiaryTopicId">
                    <mat-option [value]="0">Select a Topic</mat-option>
                    <mat-option *ngFor="let topic of tertiaryTopics" [value]="topic.topicId">{{topic.shortDescription}}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="8px" style="margin-top: 8px;">
                <mat-form-field fxFlex>
                  <mat-label>From</mat-label>
                  <input matInput [matDatepicker]="costFromPicker" placeholder="From" formControlName="from">
                  <mat-datepicker-toggle matSuffix [for]="costFromPicker"></mat-datepicker-toggle>
                  <button matSuffix mat-icon-button aria-label="Clear date" (click)="costForm.get('from')?.reset()" type="button">
                    <mat-icon style="color: red;">close</mat-icon>
                  </button>
                  <mat-datepicker #costFromPicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex>
                  <mat-label>To</mat-label>
                  <input matInput [matDatepicker]="costToPicker" placeholder="To" formControlName="to">
                  <mat-datepicker-toggle matSuffix [for]="costToPicker"></mat-datepicker-toggle>
                  <button matSuffix mat-icon-button aria-label="Clear date" (click)="costForm.get('to')?.reset()" type="button">
                    <mat-icon style="color: red;">close</mat-icon>
                  </button>
                  <mat-datepicker #costToPicker></mat-datepicker>
                </mat-form-field>
              </div>
              <div class="row" *ngIf="costs.length > 0">
                <div class="col-sm-12">
                  <hr />
                  <table class="table table-sm table-borderless wide-table">
                    <thead>
                      <tr>
                        <th scope="col">Program</th>
                        <th scope="col">Calls</th>
                        <th scope="col">Hrs : Min</th>
                        <th scope="col">Cost</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let cost of costs">
                        <td>{{cost.program}}</td>
                        <td>{{cost.calls}}</td>
                        <td>{{cost.hours}}:{{cost.minutes}}</td>
                        <td>{{cost.cost | currency}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </mat-card-content>
            <mat-card-actions align="end">
              <button mat-raised-button color="primary" type="submit">Update</button>
            </mat-card-actions>
          </mat-card>
        </form>
      </div>
    </div>
  </div>
  <div fxLayout="row" fxLayoutAlign="start stretch" style="margin-top: 10pt;">
    <div fxFlex="100">
      <form [formGroup]="countyForm" (ngSubmit)="getCountyMetrics()">
        <mat-card style="margin-bottom: 10pt;">
          <mat-card-header>
            <strong>County Counts</strong>
          </mat-card-header>
          <mat-card-content>
            <div fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px" fxLayoutAlign="start center" style="margin-bottom: 8px;">
              <mat-form-field fxFlex>
                <mat-label>From</mat-label>
                <input matInput [matDatepicker]="countyFromPicker" placeholder="From" formControlName="from">
                <mat-datepicker-toggle matSuffix [for]="countyFromPicker"></mat-datepicker-toggle>
                <button matSuffix mat-icon-button aria-label="Clear date" (click)="countyForm.get('from')?.reset()" type="button">
                  <mat-icon style="color: red;">close</mat-icon>
                </button>
                <mat-datepicker #countyFromPicker></mat-datepicker>
              </mat-form-field>
              <mat-form-field fxFlex>
                <mat-label>To</mat-label>
                <input matInput [matDatepicker]="countyToPicker" placeholder="To" formControlName="to">
                <mat-datepicker-toggle matSuffix [for]="countyToPicker"></mat-datepicker-toggle>
                <button matSuffix mat-icon-button aria-label="Clear date" (click)="countyForm.get('to')?.reset()" type="button">
                  <mat-icon style="color: red;">close</mat-icon>
                </button>
                <mat-datepicker #countyToPicker></mat-datepicker>
              </mat-form-field>
              <div fxFlex="none" style="display: flex; align-items: center;">
                <button mat-raised-button color="primary" type="submit">Update</button>
              </div>
            </div>
            <div *ngIf="countyCounts.length > 0">
              <hr />
              <div fxLayout="row" fxLayoutGap="8px" fxLayoutAlign="stretch stretch" style="width: 100%;">
                <div fxFlex *ngFor="let offset of [0,10,20,30]">
                  <div style="width: 100%;">
                    <table class="table table-sm table-borderless wide-table" style="width: 100%;">
                      <thead>
                        <tr>
                          <th scope="col">County</th>
                          <th scope="col">Count</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let count of countyCounts | slice : offset : (offset+10)">
                          <td>{{count.county}}</td>
                          <td>{{count.count}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
      </form>
    </div>
  </div>
</div>